import { Component, ViewEncapsulation, Inject } from '@angular/core';

import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialog as MatDialog,
	MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { UtilService } from '@service/util/util.service';

@Component({
	selector: 'app-quality-details-dialog',
	templateUrl: './quality-details-dialog.component.html',
	styleUrls: ['./quality-details-dialog.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class QualityDetailsDialogComponent {
	constructor(
		public dialogRef: MatDialogRef<QualityDetailsDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public utilService: UtilService
	) {}

	closeDialog(data: any): void {
		this.dialogRef.close(data);
	}
}
